module.exports = __webpack_public_path__ + "static/media/invest3.33fb011a.svg";